import Vue from 'vue'
// import { isNull } from '@/utils'
import getTranslation from '@/i18n/getTranslation'

Vue.filter('filterIsReserved', val => {
  switch (val) {
    case 1:
      return getTranslation('有预留')
    case 2:
      return getTranslation('无预留')
    default:
      return '--'
  }
})

Vue.filter('filterStatusEffective', val => {
  switch (val) {
    case 1:
      return getTranslation('生效')
    case 2:
      return getTranslation('失效（退订）')
    case -1:
      return getTranslation('失效（到期）')
    default:
      return '--'
  }
})